import Label from "../shared/label/label";
import RadioButton from "../shared/radioButton/radioButton";
import { stylizationWrapper } from "../shared/stylization";
import Wrapper from "../shared/wrapper/wrapper";
import { RadioButtonFieldProps } from "./types/radioButtonFieldProps";
import './radioButtonField.scss';
import { useEffect, useState } from "react";
import { inputStateType, validation } from "../../helpers/validation/validation";
import ErrorTip from "../shared/errorTip/errorTip";
import { TipProps } from "../shared/errorTip/types/errorTipProps";
import { ReactComponent as cancel } from '../../icons/cancel.svg';

const RadioButtonField = (props: RadioButtonFieldProps) => {
    const [errorText, setErrorText] = useState(props.tipText);
    const [errorCautionDisplay, setErrorCautionDisplay] = useState('none');
    const [inputState, setInputState] = useState('');

    var stylization = props.style !== undefined ? props.style : stylizationWrapper;

    useEffect(() => {
        if (props.validationError === true) {
            var errorText = validation(props.configValidation, props.selectedValue);
            if (errorText || (props.tipText && props.tipText !== "")) {
                if (props.tipText && props.tipText !== "") {
                    setErrorText(props.tipText);
                }
                else {
                    setErrorText(errorText);
                }
                showError();
            }
            else {
                clearError();
                showValid();
            }
        }
        else {
            clearError();
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.validationError, props.tipText, props.reload, props.selectedValue])

    const showError = () => {
        setErrorCautionDisplay('inline-block');
        setInputState(inputStateType.inputError);
    }

    const clearError = () => {
        setErrorCautionDisplay('none');
        setInputState('');
    }

    const showValid = () => {
        setInputState(inputStateType.inputValid);
    }

    const createRadioButtons = () => {
        return (<div className="radioButtonWrapper">{props.Option?.map((option, index) => {
            var checked = option.value === props.selectedValue;
            var disabled = (props.disabledValue && option.value === props.disabledValue) || (props.disabledValues && props.disabledValues.find(item => item === option.value));
            return (<RadioButton className="radioButtonObject" key={index} {...props.radioButtonProps} value={option.value} name={option.name} checked={checked} disabled={disabled}/>)
        })}</div>);
    }

    var tipProps: TipProps = {
        style: {
            display: errorCautionDisplay
        }
    }

    return (
        <Wrapper style={stylization} children={
            <>
                <Label {...props.labelProps} />
                {props.reload ? <>{createRadioButtons()}</> : createRadioButtons() }
                <ErrorTip props={tipProps} tipText={errorText} tipType={inputState === inputStateType.inputError ? 'errorTip' : undefined} additionalIcon={cancel}></ErrorTip>
            </>
        } />
    )
}

export default RadioButtonField;